<template>
    <!-- 轮播图区域 -->
    <div class="block">
        <el-carousel height="600px" style="z-index:1;">
            <el-carousel-item v-for="item in list" :key="item.id" :style="item.backeground">
                <h3 class="small ccc">
                    <a :href="item.url">
                        <img ref="bannerimg" :src="item.src" :alt="item.id" height="600" width="750">
                    </a>    
                </h3>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default{
    
    name: 'carrousel',
    data() {
        return {
            //轮播图切换时间
            interval:3000,
            list:[
                {id:1,url:"/detail?id=290",src:require('@/assets/picture/banner/banner_new1.jpg'),backeground:"background-color: #0a0702;"},
                {id:2,url:"/detail?id=347",src:require('@/assets/picture/banner/banner_new2.jpg'),backeground:"background-color: #ebcbc0;"},
                {id:3,url:"/detail?id=420",src:require('@/assets/picture/banner/banner_new3.jpg'),backeground:"background-color: #0c0704;"},
                // {id:4,url:"",src:require('@/assets/picture/banner/banner4.jpg'),backeground:"background-color: rgb(0, 0, 0);"},
                // {id:5,url:"",src:require('@/assets/picture/banner/banner5.jpg'),backeground:"background-color: rgb(10, 7, 2);"}
            ],
            mounted(){
                this.resetDocumentClientHeight()
                this.imgLoad();
                window.addEventListener('resize',() => {
                    this.imgLoad();
                },false)
            },
            methods: {
                imgLoad(){
                    this.$nextTick(()=>{
                        let ref = this.$refs
                    })
                },
                resetDocumentClientHeight(){
                    var _that=this;
                    window.onresize=()=>{
                    }
                }
            }
        }
    },
}
</script>

<style scoped>
.ccc{
    position: relative;text-align: center;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 600px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/banner.vue